export const freelanceIncomePotentialContentSectionsPart1 = [
  {
    titleKey: 'HOW_MUCH_CAN_YOU_INVOICE_AS_FREELANCER_OR_CONSULTANT',
    textKeys: [
      'FREELANCER_INVOICE_INTRO_TEXT_1',
      'FREELANCER_INVOICE_INTRO_TEXT_2',
      'FREELANCER_INVOICE_INTRO_TEXT_3'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart2 = [
  {
    titleKey: 'UNDERSTANDING_FREELANCE_AND_CONSULTANT_FEES',
    textKeys: [
      'UNDERSTANDING_FREELANCE_CONSULTANT_FEES_TEXT_1'
    ]
  },
  {
    titleKey: 'DIFFERENCES_IN_INVOICING_FREELANCE_CONSULTANT',
    textKeys: [
      'DIFFERENCES_INVOICING_FREELANCE_CONSULTANT_TEXT_1',
      'DIFFERENCES_INVOICING_FREELANCE_CONSULTANT_TEXT_2'
    ]
  },
  {
    titleKey: 'FACTORS_INFLUENCING_YOUR_FEE',
    textKeys: [
      'FACTORS_INFLUENCING_FEE_TEXT_1',
      'FACTORS_INFLUENCING_FEE_TEXT_2',
      'FACTORS_INFLUENCING_FEE_TEXT_3'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart3 = [
  {
    titleKey: 'SETTING_YOUR_FEE_AS_FREELANCER',
    textKeys: [
      'SETTING_FEE_FREELANCER_INTRO_TEXT'
    ]
  },
  {
    titleKey: 'DETERMINING_YOUR_VALUE',
    textKeys: [
      'DETERMINING_YOUR_VALUE_TEXT'
    ]
  },
  {
    titleKey: 'EVALUATE_YOUR_SKILLS_AS_FREELANCER',
    textKeys: [
      'EVALUATE_SKILLS_FREELANCER_TEXT'
    ]
  },
  {
    titleKey: 'TAKING_MARKET_CONDITIONS_INTO_ACCOUNT',
    textKeys: [
      'MARKET_CONDITIONS_TEXT'
    ]
  },
  {
    titleKey: 'INDUSTRY_ECONOMIC_SITUATION',
    textKeys: [
      'INDUSTRY_ECONOMIC_SITUATION_TEXT'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart4 = [
  {
    titleKey: 'SETTING_YOUR_FEE_AS_CONSULTANT',
    textKeys: [
      'SETTING_FEE_CONSULTANT_TEXT'
    ]
  },
  {
    titleKey: 'CONTINUAL_SKILLS_DEVELOPMENT_FOR_HIGHER_INVOICING',
    textKeys: [
      'CONTINUAL_SKILLS_DEVELOPMENT_TEXT'
    ]
  },
  {
    titleKey: 'CONSIDERING_YOUR_INDUSTRY_AND_SPECIALIZATION',
    textKeys: [
      'INDUSTRY_SPECIALIZATION_TEXT_1',
      'INDUSTRY_SPECIALIZATION_TEXT_2'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart5 = [
  {
    titleKey: 'FEES_TO_INVOICE_IN_DIFFERENT_INDUSTRIES',
    textKeys: [
      'FEES_DIFFERENT_INDUSTRIES_INTRO_TEXT'
    ]
  },
  {
    titleKey: 'FEES_IN_TECHNOLOGY_AND_IT',
    textKeys: [
      'FEES_TECHNOLOGY_IT_TEXT'
    ]
  },
  {
    titleKey: 'FEES_IN_MARKETING_AND_COMMUNICATION',
    textKeys: [
      'FEES_MARKETING_COMMUNICATION_TEXT'
    ]
  },
  {
    titleKey: 'FEES_IN_DESIGN_AND_CREATIVE_PROFESSIONS',
    textKeys: [
      'FEES_DESIGN_CREATIVE_TEXT'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart6 = [
  {
    titleKey: 'AVERAGE_HOURLY_BILLING_VARIOUS_INDUSTRIES',
    textKeys: [
      'AVERAGE_HOURLY_BILLING_INTRO_TEXT'
    ]
  },
  {
    titleKey: 'HOURLY_BILLING_WITHIN_IT_INDUSTRY',
    textKeys: [
      'HOURLY_BILLING_IT_TEXT'
    ]
  },
  {
    titleKey: 'HOURLY_BILLING_WITHIN_CREATIVE_PROFESSIONS',
    textKeys: [
      'HOURLY_BILLING_CREATIVE_TEXT'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart7 = [
  {
    titleKey: 'LIST_OF_10_POPULAR_FREELANCE_JOBS_HOURLY_RATES',
    textKeys: [
      'POPULAR_FREELANCE_JOBS_INTRO_TEXT'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart8 = [
  {
    titleKey: 'HOURLY_BILLING_IN_CONSULTING_INDUSTRY',
    textKeys: [
      'HOURLY_BILLING_CONSULTING_TEXT'
    ]
  }
];

export const freelanceIncomePotentialContentSectionsPart9 = [
  {
    titleKey: 'COMMON_QUESTIONS_FREELANCE_CONSULTING_FEES',
    textKeys: [
      'COMMON_QUESTIONS_INTRO_TEXT'
    ]
  },
  {
    titleKey: 'HOW_OFTEN_REVIEW_ADJUST_FEE',
    textKeys: [
      'REVIEW_ADJUST_FEE_TEXT'
    ]
  },
  {
    titleKey: 'HOW_HANDLE_NEGOTIATIONS_ABOUT_FEES',
    textKeys: [
      'HANDLE_NEGOTIATIONS_TEXT'
    ]
  }
];

// Popular freelance jobs data for the cards section
export const popularFreelanceJobs = [
  {
    titleKey: 'INVOICE_WEB_DEVELOPMENT_PROGRAMMING',
    rateKey: 'RATE_500_1000_SEK',
    descriptionKey: 'WEB_DEV_INCLUDES_DESC'
  },
  {
    titleKey: 'INVOICE_IT_CONSULTING_NETWORK_SECURITY',
    rateKey: 'RATE_600_1500_SEK',
    descriptionKey: 'IT_CONSULTING_INCLUDES_DESC'
  },
  {
    titleKey: 'INVOICE_GRAPHIC_DESIGN',
    rateKey: 'RATE_300_800_SEK',
    descriptionKey: 'GRAPHIC_DESIGN_INCLUDES_DESC'
  },
  {
    titleKey: 'INVOICE_DIGITAL_MARKETING',
    rateKey: 'RATE_400_2000_SEK',
    descriptionKey: 'DIGITAL_MARKETING_INCLUDES_DESC'
  },
  {
    titleKey: 'INVOICE_ACCOUNTING_FINANCIAL_ADVISORY',
    rateKey: 'RATE_500_1000_SEK',
    descriptionKey: 'ACCOUNTING_INCLUDES_DESC'
  },
  {
    titleKey: 'INVOICE_WRITER_COPYWRITING',
    rateKey: 'RATE_250_700_SEK',
    descriptionKey: 'COPYWRITING_INCLUDES_DESC'
  },
  {
    titleKey: 'INVOICE_TRANSLATION_INTERPRETATION',
    rateKey: 'RATE_300_800_SEK',
    descriptionKey: 'TRANSLATION_INCLUDES_DESC'
  },
  {
    titleKey: 'INVOICE_LEGAL_ADVICE',
    rateKey: 'RATE_800_2000_SEK',
    descriptionKey: 'LEGAL_ADVICE_INCLUDES_DESC'
  }
];
